import { usePage } from "@inertiajs/react"
import { Menu } from "lucide-react"

import imperativeIcon from "@/assets/imperative_icon.svg"
import { Button } from "@/components/ui/button"
import { useSidebar } from "@/components/ui/sidebar"
import type { Partner } from "@/types"

// The client app has no desktop header — the sidebar carries the nav. Below
// `md` the sidebar unmounts into a Sheet, so this bar is the only thing that
// can open it. Brand block mirrors AppSidebar's header.
export function AppMobileHeader() {
  const { toggleSidebar } = useSidebar()
  const partner =
    (usePage().props.partner as Partner | null | undefined) ?? null
  const displayName = partner?.name ?? "Imperative"
  const logoSrc = partner?.logo_url ?? imperativeIcon
  const logoAlt = partner?.logo_url ? partner.name : "Imperative"

  return (
    <header className="bg-background/95 sticky top-0 z-20 flex h-14 shrink-0 items-center gap-2 border-b px-2 backdrop-blur md:hidden">
      <Button
        variant="ghost"
        size="icon"
        className="size-9"
        onClick={toggleSidebar}
        aria-label="Open menu"
      >
        <Menu className="size-5" />
      </Button>
      <div className="flex min-w-0 items-center gap-2">
        <div className="flex size-7 shrink-0 items-center justify-center overflow-hidden rounded-full bg-white shadow-sm ring-1 ring-slate-900/5">
          <img
            src={logoSrc}
            alt={logoAlt}
            className="size-7 rounded-full object-cover"
          />
        </div>
        <span className="truncate text-sm font-semibold">{displayName}</span>
      </div>
    </header>
  )
}
